import { render } from "./surveyUserModel.vue?vue&type=template&id=060d39f9"
import script from "./surveyUserModel.vue?vue&type=script&lang=js"
export * from "./surveyUserModel.vue?vue&type=script&lang=js"

import "./surveyUserModel.vue?vue&type=style&index=0&id=060d39f9&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__